<template>
  <div class="register">
    <!-- 电影背景装饰 -->
    <div class="cinema-background">
      <div class="film-strip top-strip"></div>
      <div class="spotlight spotlight-1"></div>
      <div class="spotlight spotlight-2"></div>
      <div class="spotlight spotlight-3"></div>
    </div>

    <!-- 中间主体 -->
    <div class="wrapper">
      <div class="container">
        <!-- 表单容器 -->
        <div class="register-form">
          <!-- 头部 -->
          <div class="form-header">
            <div class="logo-container">
              <div class="logo-icon"></div>
              <h2>首都电影院</h2>
              <p>CAPITAL CINEMA</p>
            </div>
            <div class="form-title">
              <h3>会员注册</h3>
              <div class="title-decoration"></div>
            </div>
          </div>

          <!-- 表单主体 -->
          <div class="form-body">
            <!-- 账号输入 -->
            <div class="input-group">
              <div class="input-icon user-icon"></div>
              <input type="text" placeholder="请输入账号" v-model="rUsername" class="form-input" />
              <div class="input-focus-line"></div>
            </div>

            <!-- 密码输入 -->
            <div class="input-group">
              <div class="input-icon password-icon"></div>
              <input type="password" placeholder="请输入密码" v-model="rPassword" class="form-input" />
              <div class="input-focus-line"></div>
            </div>

            <!-- 用户协议 -->
            <div class="agreement-section">
              <span class="agreement-text">点击注册即表示同意</span>
              <span class="agreement-link" @click="showAgreement">《用户协议》</span>
            </div>

            <!-- 注册按钮 -->
            <div class="btn-group">
              <button class="register-btn" @click="register()">
                <span class="btn-text">注 册</span>
                <div class="btn-shine"></div>
              </button>
            </div>

            <!-- 底部提示 -->
            <div class="form-footer">
              <div class="footer-tips">
                <span class="tip-text">已有账号？</span>
                <span class="login-link" @click="goLogin()">立即登录</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部装饰 -->
    <div class="bottom-decoration">
      <div class="film-strip bottom-strip"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  components: {},
  data() {
    return {
      href: "index.html",
      rUsername: "",
      rPassword: "",
      logo_user: JSON.parse(window.localStorage.getItem("user")),
    };
  },
  mounted() {
    document.title = "首都电影院";
  },
  methods: {
    // 注册逻辑
    register() {
      // 获取 user
      var ruser = {
        Username: this.rUsername,
        Password: this.rPassword,
      };
      // 判断非空
      if (!this.rUsername) {
        alert("请输入用户名");
        return;
      }
      if (!this.rPassword) {
        alert("请输入密码");
        return;
      }
      window.localStorage.setItem("state", "0");
      window.localStorage.setItem("user", JSON.stringify(ruser));
      this.$router.push("/index");
      window.location.reload();
    },
    goLogin() {
      this.$router.push("/login");
    },
    showAgreement() {
      // 这里可以跳转到用户协议页面或显示弹窗
      this.$router.push("/xy");
      // 或者显示弹窗: alert("用户协议内容...");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.register {
  margin-top: 100px;
  min-height: calc(100vh - 100px);
  background: linear-gradient(135deg, #0c0c0c 0%, #1a1a1a 50%, #0c0c0c 100%);
  position: relative;
  overflow: hidden;
  padding: 25px 0;
  box-sizing: border-box;

  // 电影背景装饰
  .cinema-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    .film-strip {
      position: absolute;
      left: 0;
      width: 100%;
      height: 20px;
      background: repeating-linear-gradient(90deg,
          #000 0px,
          #000 10px,
          #ff6b6b 10px,
          #ff6b6b 20px,
          #000 20px,
          #000 30px);
      opacity: 0.3;

      &.top-strip {
        top: 0;
      }
    }

    .spotlight {
      position: absolute;
      width: 300px;
      height: 300px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(255, 107, 107, 0.1) 0%, transparent 70%);
      filter: blur(20px);

      &.spotlight-1 {
        top: 10%;
        left: 10%;
      }

      &.spotlight-2 {
        top: 60%;
        right: 15%;
      }

      &.spotlight-3 {
        bottom: 20%;
        left: 20%;
      }
    }
  }

  // 中间主体
  .wrapper {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 100px);

    .container {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      // 表单容器
      .register-form {
        width: 420px;
        background: rgba(255, 255, 255, 0.95);
        border-radius: 20px;
        padding: 40px;
        box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
        border: 1px solid rgba(255, 107, 107, 0.3);
        backdrop-filter: blur(10px);
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #ff6b6b, #ff8e8e, #ff6b6b);
        }

        // 头部
        .form-header {
          text-align: center;
          margin-bottom: 40px;

          .logo-container {
            margin-bottom: 25px;

            .logo-icon {
              width: 60px;
              height: 60px;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ff6b6b'%3E%3Cpath d='M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z'/%3E%3C/svg%3E");
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
              margin: 0 auto 15px;
            }

            h2 {
              font-size: 28px;
              font-weight: bold;
              color: #1a1a1a;
              margin-bottom: 5px;
              background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            }

            p {
              font-size: 12px;
              color: #666;
              letter-spacing: 2px;
              margin: 0;
            }
          }

          .form-title {
            h3 {
              font-size: 24px;
              font-weight: bold;
              color: #1a1a1a;
              margin-bottom: 10px;
            }

            .title-decoration {
              height: 3px;
              background: linear-gradient(90deg, #ff6b6b, transparent);
              border-radius: 2px;
              width: 60px;
              margin: 0 auto;
            }
          }
        }

        // 表单主体
        .form-body {
          .input-group {
            position: relative;
            margin-bottom: 30px;

            .input-icon {
              position: absolute;
              left: 15px;
              top: 50%;
              transform: translateY(-50%);
              width: 20px;
              height: 20px;
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
              z-index: 2;

              &.user-icon {
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23666'%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/svg%3E");
              }

              &.password-icon {
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23666'%3E%3Cpath d='M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z'/%3E%3C/svg%3E");
              }
            }

            .form-input {
              width: 100%;
              height: 50px;
              background: rgba(255, 255, 255, 0.8);
              border: 2px solid rgba(0, 0, 0, 0.1);
              border-radius: 12px;
              padding: 0 50px;
              font-size: 16px;
              color: #1a1a1a;
              transition: all 0.3s ease;
              position: relative;
              z-index: 1;

              &::placeholder {
                color: #999;
              }

              &:focus {
                outline: none;
                border-color: #ff6b6b;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.1);

                &+.input-focus-line {
                  width: 100%;
                }

                &~.input-icon {
                  &.user-icon {
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ff6b6b'%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/svg%3E");
                  }

                  &.password-icon {
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ff6b6b'%3E%3Cpath d='M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z'/%3E%3C/svg%3E");
                  }
                }
              }
            }

            .input-focus-line {
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 2px;
              background: linear-gradient(90deg, #ff6b6b, #ff8e8e);
              transition: width 0.3s ease;
              border-radius: 1px;
            }
          }

          // 用户协议
          .agreement-section {
            text-align: center;
            margin: 25px 0 30px;
            font-size: 14px;
            color: #666;

            .agreement-text {
              margin-right: 5px;
            }

            .agreement-link {
              color: #ff6b6b;
              font-weight: 500;
              cursor: pointer;
              transition: all 0.3s ease;
              position: relative;
              text-decoration: none;

              &::after {
                content: '';
                position: absolute;
                bottom: -2px;
                left: 0;
                width: 0;
                height: 1px;
                background: #ff6b6b;
                transition: width 0.3s ease;
              }

              &:hover {
                color: #ff8e8e;

                &::after {
                  width: 100%;
                }
              }
            }
          }

          // 注册按钮
          .btn-group {
            margin: 30px 0;

            .register-btn {
              width: 100%;
              height: 55px;
              background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
              border: none;
              border-radius: 15px;
              color: white;
              font-size: 18px;
              font-weight: bold;
              cursor: pointer;
              transition: all 0.3s ease;
              position: relative;
              overflow: hidden;
              box-shadow: 0 8px 25px rgba(255, 107, 107, 0.3);

              .btn-text {
                position: relative;
                z-index: 2;
              }

              .btn-shine {
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
                transition: left 0.5s ease;
              }

              &:hover {
                transform: translateY(-3px);
                box-shadow: 0 12px 30px rgba(255, 107, 107, 0.4);

                .btn-shine {
                  left: 100%;
                }
              }

              &:active {
                transform: translateY(-1px);
              }
            }
          }

          // 底部提示
          .form-footer {
            text-align: center;

            .footer-tips {
              .tip-text {
                font-size: 14px;
                color: #666;
              }

              .login-link {
                font-size: 14px;
                color: #ff6b6b;
                font-weight: bold;
                cursor: pointer;
                margin-left: 8px;
                transition: all 0.3s ease;
                text-decoration: none;
                position: relative;

                &::after {
                  content: '';
                  position: absolute;
                  bottom: -2px;
                  left: 0;
                  width: 0;
                  height: 1px;
                  background: #ff6b6b;
                  transition: width 0.3s ease;
                }

                &:hover {
                  color: #ff8e8e;

                  &::after {
                    width: 100%;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  // 底部装饰
  .bottom-decoration {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;

    .film-strip {
      height: 20px;
      background: repeating-linear-gradient(90deg,
          #000 0px,
          #000 10px,
          #ff6b6b 10px,
          #ff6b6b 20px,
          #000 20px,
          #000 30px);
      opacity: 0.3;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .register {
    .wrapper {
      .container {
        padding: 0 15px;

        .register-form {
          width: 100%;
          max-width: 400px;
          padding: 30px 25px;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .register {
    .wrapper {
      .container {
        .register-form {
          padding: 25px 20px;

          .form-header {
            .logo-container {
              h2 {
                font-size: 24px;
              }
            }

            .form-title {
              h3 {
                font-size: 20px;
              }
            }
          }
        }
      }
    }
  }
}
</style>